import type { ModuleFilterStrategy, FilterRequestContext } from '../components/common/filterStrategy';
import { defaultFilterStrategy } from '../components/common/filterStrategy';
import { DEFAULT_PROCESSING_PRIORITIES } from '../components/trail/trialConstants';
import { getSplotStatusIdsByTab, getTrialStatusIdsByTab } from './statusUtils';

const PERCENTAGE_FILTER_OPTIONS = [
  { id: 'lt25', value: '<25%', apiValue: '25' },
  { id: '25to50', value: '25-50%', apiValue: '25-50' },
  { id: '50to75', value: '50-75%', apiValue: '50-75' },
  { id: 'gt75', value: '>75%', apiValue: '75' },
];

const splotStrategy: ModuleFilterStrategy = {
  getTabStatusOverlay(tab: string, runtimeContext?: { listValues?: any }) {
    if (tab === 'High priority MatIDs') return { status_id: [], priority: ['high'] };
    const splotStatuses = runtimeContext?.listValues?.statuses ?? [];
    return { status_id: getSplotStatusIdsByTab(tab, splotStatuses), priority: [] };
  },
  augmentRequest(req: Record<string, any>, ctx: FilterRequestContext) {
    req.is_archive = ctx.showArchived;
    req.site_code = [ctx.siteSelected];
    return req;
  },
};

const trialStrategy: ModuleFilterStrategy = {
  getTabStatusOverlay(tab: string, runtimeContext?: { listValues?: any }) {
    if (tab === 'High priority MatIDs') return { trial_status_id: [], priority: ['High'] };
    const trialStatuses = runtimeContext?.listValues?.trialStatus ?? [];
    return { trial_status_id: getTrialStatusIdsByTab(tab, trialStatuses), priority: [] };
  },
  augmentRequest(req: Record<string, any>, ctx: FilterRequestContext) {
    req.is_archive = ctx.showArchived;
    req.site_code = ctx.siteSelected;
    if (ctx.paginationModel) {
      req.page = 1;
      req.page_size = ctx.paginationModel.pageSize;
    }
    return req;
  },
};

const workflowStrategy: ModuleFilterStrategy = {
  getTabStatusOverlay: () => ({}),
  augmentRequest(req: Record<string, any>) {
    if (req.workflow_name) {
      req.protocol_title = req.workflow_name;
      delete req.workflow_name;
    }
    return req;
  },
};

const trialDrillStrategy: ModuleFilterStrategy = {
  getTabStatusOverlay: () => ({}),
  augmentRequest(req: Record<string, any>, ctx: FilterRequestContext) {
    if (ctx.extraContext?.trial_bid) {
      req.trial_bid = ctx.extraContext.trial_bid;
    }
    if (ctx.paginationModel) {
      req.page = ctx.paginationModel.page === 0 ? 1 : ctx.paginationModel.page;
      req.page_size = ctx.paginationModel.pageSize;
    }
    return req;
  },
};


const inSeasonTrialStrategy: ModuleFilterStrategy = {
  getTabStatusOverlay: () => ({}),

  augmentRequest(req: Record<string, any>, ctx: FilterRequestContext) {

    if (ctx.paginationModel) {
      req.page = 1,
        req.page_size = ctx.paginationModel.pageSize;
    }
    req.site_code = ctx.siteSelected;
    
    // Rename crop to crop_code for search API
    if (req.crop !== undefined) {
      req.crop_code = req.crop;
      delete req.crop;
    }
    
    return req;
  },
};
const inSeasonTrialMatStrategy: ModuleFilterStrategy = {
  getTabStatusOverlay: () => ({}),

  augmentRequest(req: Record<string, any>, ctx: FilterRequestContext) {

    if (ctx.extraContext?.trial_id) {
      req.trial_id = ctx.extraContext.trial_id;
    }
    req.site_code = ctx.siteSelected
    return req;
  },
};




export const FilterConFig: any = {
  "splot": {
    "strategy": splotStrategy,
    "fields": [
      {
        type: "textMulti",
        placeholder: "Enter SP Lot ID",
        name: "splot_id",
        label: "SP Lot",
        defaultValue: ""
      },

      {
        type: "textMulti",
        placeholder: "Enter Material ID",
        name: "material_id",
        label: "Material ID",
        defaultValue: "",
        passZeroIfBlank: true
      },

      {
        type: "textMulti",
        placeholder: "Enter Trial ID",
        name: "trial_id",
        label: "Trail ID",
        defaultValue: ""
      },
      {
        type: "textMulti",
        placeholder: "Enter Sector",
        name: "sector",
        label: "Sector",
        defaultValue: ""
      },

      {
        type: "select",
        placeholder: "Select Crop",
        name: "crop_code",
        label: "Crop",
        defaultValue: [],
        list: "crops",
        listKey: "crop_xrd_oid",
        listValue: "name",
        isFirstAccordian: true,
        displayNameOnSel: true
      },
      {
        type: "select",
        placeholder: "Select Status",
        name: "status_id",
        label: "Status",
        list: "statuses",
        listKey: "status_id",
        listValue: "status_value",
        defaultValue: [],
        convertToNumber: true,
        displayNameOnSel: true
      },
      {
        type: "select",
        placeholder: "Select Priority",
        name: "priority",
        label: "Priority",
        defaultValue: [],
        list: "priority",
        listKey: "id",
        listValue: "value",
        displayNameOnSel: true
      },
      {
        type: "dateRange",
        placeholder: "Last Updated on",
        name: "LastUpdatedOn",
        label: "Last Updated on",
        reqKey: "from_date-to_date",
        defaultValue: [null, null]
      },
    ],
    "createFilter": "/api/v1/splot-filters",
    "searchFilter": "/api/v1/splots-search",
    "getSavesFilters": "/api/v1/splot-filters",
    "getSavesFiltersPathParams": ["user_id", "is_archive"],
    "deleteFilter": "/api/v1/splot-filters",
    "filter_name_key": "splot_filter_name",
    "filter_id_key": "splot_filter_id"
  },
  "user": {
    "strategy": defaultFilterStrategy,
    "fields": [
      {
        type: "PeoplePicker",
        placeholder: "Enter Username",
        name: "username",
        label: "User Name",
        defaultValue: "",
        reqKey: "username"
      },

      {
        type: "select",
        placeholder: "Select Role",
        name: "role_id",
        label: "Role",
        defaultValue: [],
        list: "allRoles",
        listKey: "role_id",
        listValue: "name",
        displayNameOnSel: true,
        isFirstAccordian: true,
        convertToNumber: true,

      },
      {
        type: "select",
        placeholder: "Select Module ",
        name: "module_id",
        label: "Module",
        defaultValue: [],
        list: "allModules",
        listKey: "module_id",
        listValue: "name",
        displayNameOnSel: true,
        convertToNumber: true,
      },
      {
        type: "select",
        placeholder: "Select Site",
        name: "site_code",
        label: "Site",
        defaultValue: [],
        list: "sitesData",
        listKey: "site_code",
        listValue: "site_name",
        displayNameOnSel: true,

      },
    ],
    "getSavesFilters": "/api/common/v1/user_filters",
    "createFilter": "/api/common/v1/user_filter",
    "searchFilter": "/api/common/v1/search-users",
    "filter_name_key": "user_filter_name",
    "filter_id_key": "user_filter_id",
    "deleteFilter": "/api/common/v1/delete-user-filter",
    "deleteFilterMode": "body"
  },
  "workflow": {
    "strategy": workflowStrategy,
    "fields": [
      {
        type: "select",
        placeholder: "Select Workflow Name",
        name: "workflow_name",
        label: "Workflow Name",
        defaultValue: [],
        list: "workflowNames",
        listKey: "name",
        listValue: "name",

        displayNameOnSel: true
      },
      {
        type: "select",
        placeholder: "Select Crop",
        name: "crop_code",
        label: "Crop",
        defaultValue: [],
        list: "crops",
        listKey: "code",
        listValue: "name",
        displayNameOnSel: true

      },
      {
        type: "select",
        placeholder: "Select Site",
        name: "site_code",
        label: "Site",
        defaultValue: [],
        list: "sites",
        listKey: "full_code",
        listValue: "site_name",

      },
      {
        type: "select",
        placeholder: "Select Year",
        name: "year",
        label: "Year",
        defaultValue: [],
        list: "years",
        listKey: "year",
        listValue: "year",
        convertToNumber: true,

      },
      {
        type: "select",
        placeholder: "Select Steps",
        name: "steps",
        label: "Protocol Steps",
        defaultValue: [],
        list: "steps",
        listKey: "workflow_step_id",
        listValue: "workflow_step_name",
        convertToNumber: true,
        displayNameOnSel: true,
      },
      {
        type: "select",
        placeholder: "Select Status",
        name: "status",
        label: "Status",
        defaultValue: [],
        list: "statuses",
        listKey: "id",
        listValue: "name",

        displayNameOnSel: true
      }
    ],
    "createFilter": "/api/v1/workflow-filters",
    "searchFilter": "/api/v1/search-workflow",
    "getSavesFilters": "/api/v1/workflow-filters",
    "getSavesFiltersPathParams": ["user_id"],
    "deleteFilter": "/api/v1/workflow-filters",
    "filter_name_key": "workflow_filter_name",
    "filter_id_key": "workflow_filter_id"
  },
  "trial": {
    "strategy": trialStrategy,
    "fields": [
      {
        type: "textMulti",
        placeholder: "Enter Trial ID",
        name: "trial_id",
        label: "Trial ID",
        defaultValue: ""
      },
      {
        type: "textMulti",
        placeholder: "Enter Greenhouse Location",
        name: "sector",
        label: "Greenhouse Location",
        defaultValue: ""
      },
      {
        type: "textMulti",
        placeholder: "Enter Description",
        name: "local_code",
        label: "Description",
        defaultValue: ""
      },
      {
        type: "select",
        placeholder: "Select Crop",
        name: "crop",
        label: "Crop",
        defaultValue: [],
        list: "crops",
        listKey: "crop_xrd_oid",
        listValue: "name",
        displayNameOnSel: true,
        isFirstAccordian: true
      },
      {
        type: "select",
        placeholder: "Select Trail Status",
        name: "trial_status_id",
        label: "Trial Status",
        defaultValue: [],
        list: "trialStatus",
        listKey: "status_id",
        listValue: "status_value",
        convertToNumber: true,
        displayNameOnSel: true,
      },
      {
        type: "select",
        placeholder: "Select Mat ID Completion %",
        name: "matid_completion",
        label: "Mat ID Completion %",
        defaultValue: [],
        list: PERCENTAGE_FILTER_OPTIONS,
        listKey: "id",
        listValue: "value",
        transformKey: "apiValue",
        displayNameOnSel: true,
        nullIfEmpty: true
      },
      {
        type: "dateRange",
        placeholder: "Start Date",
        name: "startDate",
        label: "Start Date",
        reqKey: "from_date-to_date",
        defaultValue: [null, null]
      },

      {
        type: "dateRange",
        placeholder: "Last Updated On ",
        name: "LastUpdateOn",
        label: "Last Updated On",
        reqKey: "last_updated_from-last_updated_to",
        defaultValue: [null, null]
      },

    ],
    "createFilter": "api/v1/trial-filters",
    "searchFilter": "api/v1/postseason-filtered-trials",
    "getSavesFilters": "api/v1/trial-filters",
    "getSavesFiltersPathParams": ["user_id", "is_archive"],
    "deleteFilter": "api/v1/trial-filters",
    "filter_name_key": "trial_filter_name",
    "filter_id_key": "trial_filter_id",
    "responseDataKey": "trial_data",
    "paginationKey": "pagination"
  },
  "trial_drill": {
    "strategy": trialDrillStrategy,
    "fields": [
      // {
      //   type: "textMulti",
      //   placeholder: "Enter Trial Bid",
      //   name: "trial_bid",
      //   label: "Trial Bid",
      //   defaultValue: ""
      // },
      {
        type: "textMulti",
        placeholder: "Enter Material ID",
        name: "material_id",
        label: "Material ID",
        defaultValue: "",
      },
      {
        type: "textMulti",
        placeholder: "Enter Pollination ID",
        name: "pollination_id",
        label: "Pollination ID",
        defaultValue: "",
      },
      {
        type: "textMulti",
        placeholder: "Enter Barcode",
        name: "barcode",
        label: "Barcode",
        defaultValue: "",
      },
      {
        type: "textMulti",
        placeholder: "Enter Admin Code",
        name: "admin_code",
        label: "Admin Code",
        defaultValue: "",
      },
      {
        type: "textMulti",
        placeholder: "Enter Greenhouse Location",
        name: "sector",
        label: "Greenhouse Location",
        defaultValue: "",
      },
      {
        type: "textMulti",
        placeholder: "",
        name: "pollination_type",
        label: "Pollination Type",
        defaultValue: "",
        // list: "pollinationTypes",
        // listKey: "id",
        // listValue: "value",
        // displayNameOnSel: true
      },
      {
        type: "textMulti",
        placeholder: "Enter Type/Segment",
        name: "type_segment",
        label: "Type/Segment",
        defaultValue: "",
      },
      {
        type: "text",
        placeholder: "Enter HRVMD",
        name: "hrvmd",
        label: "HRVMD",
        defaultValue: ""
      },
      {
        type: "textMulti",
        placeholder: "Enter Special Requisites",
        name: "special_requisites",
        label: "Special Requisites",
        defaultValue: "",
      },
      {
        type: "select",
        placeholder: "Enter Processing Priority",
        name: "processing_priority",
        label: "Processing Priority",
        defaultValue: [],
        list: [...DEFAULT_PROCESSING_PRIORITIES],
        listKey: "id",
        listValue: "value",
        displayNameOnSel: true
      },
      {
        type: "textMulti",
        placeholder: "Enter SAPNR",
        name: "sapnr",
        label: "SAPNR",
        defaultValue: "",
      },
      {
        type: "number",
        placeholder: "Enter Harvest Count",
        name: "harvest_count",
        label: "Harvests",
        defaultValue: "",   
        nullIfEmpty:true,
      },
      {
        type: "textMulti",
        placeholder: "Enter Subplot ID",
        name: "plants_to_harvest",
        label: "Subplot ID",
        defaultValue: "",   
        nullIfEmpty:true
      },
      {
        type: "textMulti",
        placeholder: "Enter Generation Code",
        name: "material_generation",
        label: "Generation Code",
        defaultValue: "",
      },
      {
        type: "textMulti",
        placeholder: "Enter Stage Code",
        name: "material_stage_code",
        label: "Stage Code",
        defaultValue: "",
      },
      {
        type: "number",
        placeholder: "Enter Required Fruit Count",
        name: "required_fruit_count",
        label: "Required Fruit Count",
        defaultValue: "",      
        min: 0,
        max: 1000,
        nullIfEmpty:true
      },
      {
        type: "number",
        placeholder: "Enter Required Seed Weight (g)",
        name: "required_seed_weight_g",
        label: "Required Seed Weight (g)",
        defaultValue: "",      
        min: 0,
        max: 1000,
        nullIfEmpty:true
      },
      {
        type: "number",
        placeholder: "Enter Required Seed Count",
        name: "required_seed_count",
        label: "Required Seed Count",
        defaultValue: "",        
        min: 0,
        max: 1000,
        nullIfEmpty:true
      },
      {
        type: "number",
        placeholder: "Enter Fruit Weight (g)",
        name: "fruit_weight_g",
        label: "Fruit Weight (g)",
        defaultValue: "",   
        min: 0,
        max: 1000,
        nullIfEmpty:true
      },
      {
        type: "number",
        placeholder: "Enter Bags",
        name: "bags",
        label: "Bags",
        defaultValue: "",      
        min: 0,
        max: 1000,
        nullIfEmpty:true
      },
      {
        type: "textMulti",
        placeholder: "Enter Registered Container",
        name: "container_id",
        label: "Registered Container",
        defaultValue: "",
      },
      {
        type: "number",
        placeholder: "Enter Fruit Count",
        name: "fruit_count",
        label: "Fruit Count",
        defaultValue: "",     
        min: 0,
        max: 1000,
        nullIfEmpty:true
      },
      {
        type: "number",
        placeholder: "Enter Seed Weight (g)",
        name: "seed_weight_g",
        label: "Seed Weight (g)",
        defaultValue: "",   
        min: 0,
        max: 1000,
         nullIfEmpty:true
        
      },
      {
        type: "number",
        placeholder: "Enter Seed Count",
        name: "seed_count",
        label: "Seed Count",
        defaultValue: "",  
        min: 0,
        max: 1000,
        nullIfEmpty:true
      },
      {
        type: "select",
        placeholder: "Select Goal Achieved %",
        name: "goal_achieved_pct",
        label: "Goal Achieved %",
        defaultValue: [],
        list: PERCENTAGE_FILTER_OPTIONS,
        listKey: "id",
        listValue: "value",
        transformKey: "apiValue",
        displayNameOnSel: true,
        nullIfEmpty: true
      },
      {
        type: "select",
        placeholder: "",
        name: "material_status",
        label: "Status",
        list: "matStatusList",
        listKey: "value",
        listValue: "value",
        defaultValue: [],
        displayNameOnSel: true
      },
      {
        type: "textMulti",
        placeholder: "Enter Remarks",
        name: "remarks",
        label: "Remarks",
        defaultValue: "",
      },
    ],
    "createFilter": "/api/v1/trial-material-filters",
    "searchFilter": "/api/v1/filter-trial-materials",
    "getSavesFilters": "/api/v1/trial-material-filters",
    "getSavesFiltersPathParams": ["user_id"],
    "deleteFilter": "/api/v1/trial-material-filters",
    "deleteFilterPathKey": "filter_name",
    "filter_name_key": "filter_name",
    "filter_id_key": "trial_material_filter_id",
    "responseDataKey": "materials",
    "paginationKey": "pagination"
  },

  inSeasonTrials: {
    "strategy": inSeasonTrialStrategy,
    "fields": [
      {
        type: "textMulti",
        placeholder: "Enter Trial ID",
        name: "trial_id",
        label: "Trial ID",
        defaultValue: "",
        reqKey: "trial_id"
      },

      {
        type: "textMulti",
        placeholder: "Enter Greenhouse Location",
        name: "sector",
        label: "Greenhouse Location",
        defaultValue: "",
        reqKey: "sector"

      },
      {
        type: "select",
        placeholder: "Select crop",
        name: "crop_code",
        label: "Crop",
        defaultValue: [],
        list: "crops",
        listKey: "crop_xrd_oid",
        listValue: "name",
        isFirstAccordian: true,
        displayNameOnSel: true,
        altKey: "crop"  // Backward compatibility: saved filters might have 'crop' instead of 'crop_code'
      },
      {
        type: "textMulti",
        placeholder: "Select Description",
        name: "local_code",
        label: "Description",
        defaultValue: "",
        reqKey: "local_code"
      },
      {
        type: "radio",
        placeholder: "Select Submission Status",
        name: "IsSubmitted",
        label: "Is Submitted",
        defaultValue: "",
        list: [
          { id: true, value: "True" },
          { id: false, value: "False" },
        ],
        listKey: "id",
        listValue: "value",
        displayNameOnSel: true
      },
    ],
    "getSavesFilters": "/in-season-api/v1/trial-filters",
    "createFilter": "/in-season-api/v1/trial-filters",
    "searchFilter": "/in-season-api/v1/search-trials",
    "filter_name_key": "trial_filter_name",
    "filter_id_key": "trial_filter_id",
    "deleteFilter": "/in-season-api/v1/trial-filters",
    "deleteFilterMode": "body",
    "responseDataKey": "trial_data",
    "paginationKey": "pagination"
  },
  inSeasonTrialsMat: {
    "strategy": inSeasonTrialMatStrategy,
    "fields": [
      {
        type: "textMulti",
        placeholder: "Enter Material ID",
        name: "mat_id",
        label: "Material ID",
        defaultValue: "",
        reqKey: "mat_id"
      },
      // {
      //   type: "textMulti",
      //   placeholder: "Enter Trial ID",
      //   name: "trial_id",
      //   label: "Trial ID",
      //   defaultValue: "",
      //   reqKey: "trail_id"

      // },
      {
        type: "textMulti",
        placeholder: "Select Greenhouse Location",
        name: "sector",
        label: "Greenhouse Location",
        defaultValue: "",
        reqKey: "sector"

      },
      {
        type: "textMulti",
        placeholder: "Select Pollination ID",
        name: "pollination_id",
        label: "Pollination ID",
        reqKey: "pollination_id",
        defaultValue: "",

      },
      {
        type: "textMulti",
        placeholder: "Enter Admin Code",
        name: "admin_code",
        label: "Admin Code",
        reqKey: "admin_code",
        defaultValue: "",

      },
      {
        type: "textMulti",
        placeholder: "Select Subplot ID",
        name: "plants_to_harvest",
        label: "Subplot ID",
        reqKey: "plants_to_harvest",
        defaultValue: "",
         nullIfEmpty:true

      },
      {
        type: "textMulti",
        placeholder: "Select HRVMD",
        name: "hrvmd",
        label: "HRVMD",
        reqKey: "hrvmd",
        defaultValue: "",

      },
      {
        type: "textMulti",
        placeholder: "Select Pollination type",
        name: "pollination_type",
        label: "Pollination type",
        defaultValue: "",
        reqKey: "pollination_type",

      },
      {
        type: "textMulti",
        placeholder: "Select Barcode",
        name: "barcd",
        label: "Barcode",
        defaultValue: "",
        reqKey: "barcd",


      },
      {
        type: "textMulti",
        placeholder: "Select Generation Code",
        name: "material_generation",
        label: "Generation Code",
        defaultValue: "",
        reqKey: "material_generation",

      },

      {
        type: "textMulti",
        placeholder: "Select Stage Code",
        name: "material_stage_code",
        label: "Stage Code",
        defaultValue: "",

      },
      {
        type: "select",
        placeholder: "Select Processing Priority",
        name: "processing_priority",
        label: "Processing Priority",
        list: "priorityArr",
        listKey: "id",
        listValue: "value",
        defaultValue: [],

      },
      {
        type: "textMulti",
        placeholder: "Select Special Requisites",
        name: "special_requisites",
        label: "Special Requisites",
        defaultValue: "",

      },

      {
        type: "text",
        placeholder: "Select Type/Segment",
        name: "type_segment",
        label: "Type/Segment",
        defaultValue: "",

      },
      {
        type: "number",
        placeholder: "Enter Required Seed Weight (g)",
        name: "required_seed_weight_g",
        label: "Required Seed Weight (g)",
        defaultValue: "",
        nullIfEmpty: true,
        min: 0,
        max: 1000
      },
      {
        type: "number",
        placeholder: "Enter Required Fruit Count",
        name: "required_fruit_weight_g",
        label: "Required Fruit Count",
        defaultValue: "",
        nullIfEmpty: true,
        min: 0,
        max: 1000
      },
      {
        type: "number",
        placeholder: "Enter Required Seed Count",
        name: "required_seed_count",
        label: "Required Seed Count",
        defaultValue: "",
        nullIfEmpty: true,
        min: 0,
        max: 1000
      },
      {
        type: "textMulti",
        placeholder: " Description",
        name: "local_code",
        label: "Description",
        defaultValue: "",

      },

      {
        type: "number",
        placeholder: "Type/Segment Yield(g)",
        name: "type_segment_yield_g",
        label: "Type/Segment Yield(g)",
        defaultValue: "",
        nullIfEmpty:true

      },
    ],
    "getSavesFilters": "/in-season-api/v1/trial-drill-down-filters",
    "createFilter": "/in-season-api/v1/trial-drill-down-filters",
    "searchFilter": "/in-season-api/v1/search-trial-materials",
    "filter_name_key": "trial_filter_name",
    "filter_id_key": "drill_down_filter_id",
    "deleteFilter": "/in-season-api/v1/trial-drill-down-filters",
    "deleteFilterMode": "body",
    "paginationKey":"totals"
  },
}
